module.exports = __webpack_public_path__ + "img/70007.c2437571.png";